// Norwegian (Bokmål) translation for PrimeVue components (DatePicker, Select,
// data tables, etc). Passed as the `locale` option wherever the app calls
// `app.use(PrimeVue, ...)`, since PrimeVue defaults to English (Sunday-first
// weeks, English month/day names) when no locale is configured.
export default {
    startsWith: 'Starter med',
    contains: 'Inneholder',
    notContains: 'Inneholder ikke',
    endsWith: 'Slutter med',
    equals: 'Er lik',
    notEquals: 'Er ikke lik',
    noFilter: 'Ingen filter',
    lt: 'Mindre enn',
    lte: 'Mindre enn eller lik',
    gt: 'Større enn',
    gte: 'Større enn eller lik',
    dateIs: 'Dato er',
    dateIsNot: 'Dato er ikke',
    dateBefore: 'Dato er før',
    dateAfter: 'Dato er etter',
    clear: 'Nullstill',
    apply: 'Bruk',
    matchAll: 'Alle kriterier',
    matchAny: 'Ett av kriteriene',
    addRule: 'Legg til regel',
    removeRule: 'Fjern regel',
    accept: 'Ja',
    reject: 'Nei',
    choose: 'Velg',
    upload: 'Last opp',
    cancel: 'Avbryt',
    completed: 'Fullført',
    pending: 'Venter',
    fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    dayNames: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
    dayNamesShort: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
    dayNamesMin: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
    monthNames: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'],
    monthNamesShort: ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
    chooseYear: 'Velg år',
    chooseMonth: 'Velg måned',
    chooseDate: 'Velg dato',
    prevDecade: 'Forrige tiår',
    nextDecade: 'Neste tiår',
    prevYear: 'Forrige år',
    nextYear: 'Neste år',
    prevMonth: 'Forrige måned',
    nextMonth: 'Neste måned',
    prevHour: 'Forrige time',
    nextHour: 'Neste time',
    prevMinute: 'Forrige minutt',
    nextMinute: 'Neste minutt',
    prevSecond: 'Forrige sekund',
    nextSecond: 'Neste sekund',
    am: 'am',
    pm: 'pm',
    today: 'I dag',
    weekHeader: 'Uke',
    firstDayOfWeek: 1,
    showMonthAfterYear: false,
    dateFormat: 'dd.mm.yy',
    weak: 'Svakt',
    medium: 'Middels',
    strong: 'Sterkt',
    passwordPrompt: 'Skriv inn et passord',
    emptyFilterMessage: 'Ingen resultater funnet',
    searchMessage: '{0} resultater tilgjengelig',
    selectionMessage: '{0} elementer valgt',
    emptySelectionMessage: 'Ingen valgte elementer',
    emptySearchMessage: 'Ingen resultater funnet',
    fileChosenMessage: '{0} filer',
    noFileChosenMessage: 'Ingen fil valgt',
    emptyMessage: 'Ingen tilgjengelige valg',
    aria: {
        trueLabel: 'Sant',
        falseLabel: 'Usant',
        nullLabel: 'Ikke valgt',
        star: '1 stjerne',
        stars: '{star} stjerner',
        selectAll: 'Alle elementer valgt',
        unselectAll: 'Alle elementer fjernet',
        close: 'Lukk',
        previous: 'Forrige',
        next: 'Neste',
        navigation: 'Navigasjon',
        scrollTop: 'Til toppen',
        moveTop: 'Flytt til topp',
        moveUp: 'Flytt opp',
        moveDown: 'Flytt ned',
        moveBottom: 'Flytt til bunn',
        moveToTarget: 'Flytt til mål',
        moveToSource: 'Flytt til kilde',
        moveAllToTarget: 'Flytt alle til mål',
        moveAllToSource: 'Flytt alle til kilde',
        pageLabel: 'Side {page}',
        firstPageLabel: 'Første side',
        lastPageLabel: 'Siste side',
        nextPageLabel: 'Neste side',
        prevPageLabel: 'Forrige side',
        rowsPerPageLabel: 'Rader per side',
        jumpToPageDropdownLabel: 'Gå til side',
        jumpToPageInputLabel: 'Gå til side',
        selectRow: 'Rad valgt',
        unselectRow: 'Rad fjernet',
        expandRow: 'Rad utvidet',
        collapseRow: 'Rad kollapset',
        showFilterMenu: 'Vis filtermeny',
        hideFilterMenu: 'Skjul filtermeny',
        filterOperator: 'Filteroperator',
        filterConstraint: 'Filterbegrensning',
        editRow: 'Rediger rad',
        saveEdit: 'Lagre endring',
        cancelEdit: 'Avbryt endring',
        listView: 'Listevisning',
        gridView: 'Rutenettvisning',
        slide: 'Lysbilde',
        slideNumber: '{slideNumber}',
        zoomImage: 'Zoom bilde',
        zoomIn: 'Zoom inn',
        zoomOut: 'Zoom ut',
        rotateRight: 'Roter høyre',
        rotateLeft: 'Roter venstre',
        listLabel: 'Valgliste',
    },
};
